import { setGlobal, setGlobalAndPersist } from '../../global/useGlobal'
import { platformConfig } from '../../constants/platform'

export const saveAuthResult = async (gqlResponse?: any) => {
  if (!gqlResponse) {
    return console.warn('saveAuthResult: invalid gqlResponse provided:', gqlResponse)
  }
  const auth = {
    authToken: gqlResponse?.extensions?.authorization?.token,
    refreshToken: gqlResponse?.extensions?.authorization?.refreshToken,
    uid: gqlResponse?.extensions?.authorization?.uid,
  }
  await setGlobalAndPersist(auth)
  // platformConfig.isWeb() ? await setGlobal(auth) : await setGlobalAndPersist(auth)
}
